/* Units for the size-reference captions (sections/3-images.liquid).
   Markup contract: a [data-sk-units] root holding
   [data-sk-units-show="metric|us|uk"] spans (all but metric start
   hidden) and a hidden [data-sk-units-toggle] group of
   <button data-sk-units-set="metric|imperial"> switches and
   <button data-sk-units-change> actions for the opposite system.
   The default comes from the device time zone, not Shopify's country:
   a first visit without a localization cookie is always rendered as
   US, wherever the visitor is. US and Canada time zones get ft/in + lb,
   UK ones ft/in + stones, everyone else cm/kg. A choice made with the
   switch is remembered for later pages.
   Lives in an external file (not inline) because the storefront's
   instant-loader app swaps page content into the DOM, and inline
   scripts injected that way never execute. Clicks are delegated and a
   MutationObserver re-applies the units to swapped-in sections. */
(function () {
	if (window.SKSizeUnits) return;
	window.SKSizeUnits = true;

	var STORAGE_KEY = 'sk-size-units';
	var US_CA_ZONES = /^(America\/(New_York|Chicago|Denver|Los_Angeles|Phoenix|Anchorage|Detroit|Boise|Juneau|Sitka|Nome|Yakutat|Metlakatla|Adak|Menominee|Indiana\/.+|Kentucky\/.+|North_Dakota\/.+|Toronto|Montreal|Vancouver|Edmonton|Winnipeg|Halifax|St_Johns|Regina|Moncton|Glace_Bay|Goose_Bay|Whitehorse|Dawson|Dawson_Creek|Fort_Nelson|Creston|Swift_Current|Iqaluit|Rankin_Inlet|Resolute|Cambridge_Bay|Inuvik|Atikokan|Blanc-Sablon|Nipigon|Thunder_Bay|Rainy_River|Pangnirtung|Yellowknife)|Pacific\/Honolulu|US\/.+|Canada\/.+)$/;
	var UK_ZONES = /^(Europe\/(London|Belfast|Guernsey|Jersey|Isle_of_Man)|GB|GB-Eire)$/;

	// 'us' | 'uk' | 'metric'
	var region = (function () {
		var zone = '';
		try {
			zone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
		} catch (e) {}
		if (UK_ZONES.test(zone)) return 'uk';
		if (US_CA_ZONES.test(zone)) return 'us';
		return 'metric';
	})();

	// choice made on this page, for when storage is unavailable
	var chosen = null;

	function savedSystem() {
		try {
			var value = localStorage.getItem(STORAGE_KEY);
			if (value === 'metric' || value === 'imperial') return value;
		} catch (e) {}
		return null;
	}

	// 'metric' | 'imperial'
	function currentSystem() {
		return chosen || savedSystem() || (region === 'metric' ? 'metric' : 'imperial');
	}

	function apply(root) {
		var system = currentSystem();
		var variant = system === 'metric' ? 'metric' : region === 'uk' ? 'uk' : 'us';
		root.querySelectorAll('[data-sk-units-show]').forEach(function (el) {
			el.hidden = el.getAttribute('data-sk-units-show') !== variant;
		});
		root.querySelectorAll('[data-sk-units-set]').forEach(function (btn) {
			btn.setAttribute('aria-pressed', btn.getAttribute('data-sk-units-set') === system ? 'true' : 'false');
			var ukLabel = btn.getAttribute('data-label-uk');
			if (region === 'uk' && ukLabel && btn.textContent !== ukLabel) {
				btn.textContent = ukLabel;
			}
		});
		root.querySelectorAll('[data-sk-units-change]').forEach(function (btn) {
			var label = system === 'imperial' ? 'data-label-metric' : region === 'uk' ? 'data-label-uk' : 'data-label-imperial';
			var text = btn.getAttribute(label);
			if (btn.textContent !== text) btn.textContent = text;
		});
		root.querySelectorAll('[data-sk-units-toggle]').forEach(function (toggle) {
			toggle.hidden = false;
		});
	}

	function applyAll() {
		document.querySelectorAll('[data-sk-units]').forEach(apply);
	}

	document.addEventListener('click', function (e) {
		var btn = e.target.closest('[data-sk-units-set], [data-sk-units-change]');
		if (!btn) return;
		chosen = btn.hasAttribute('data-sk-units-change')
			? currentSystem() === 'metric' ? 'imperial' : 'metric'
			: btn.getAttribute('data-sk-units-set');
		try {
			localStorage.setItem(STORAGE_KEY, chosen);
		} catch (e2) {}
		applyAll();
	});

	applyAll();

	// only react when a size-reference section is added (instant-loader swap)
	new MutationObserver(function (mutations) {
		for (var i = 0; i < mutations.length; i++) {
			var added = mutations[i].addedNodes;
			for (var j = 0; j < added.length; j++) {
				var node = added[j];
				if (node.nodeType !== 1) continue;
				if (node.matches('[data-sk-units]')) {
					apply(node);
				} else {
					node.querySelectorAll('[data-sk-units]').forEach(apply);
				}
			}
		}
	}).observe(document.body, { childList: true, subtree: true });
})();
